module.exports = __webpack_public_path__ + "static/media/Починенный.1296dda5.jpg";